module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "h1"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('nav', {
    attrs: {
      "epub:type": "toc",
      "id": "toc"
    }
  }, [_c('ol', {
    staticClass: "tocol"
  }, [_c('li', {
    staticClass: "table-of-content"
  }, [_c('a', {
    attrs: {
      "href": "#/0_chapter1damingxinjun"
    }
  }, [_vm._v("CHAPTER 1 - DAMING XINJUN")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('a', {
    attrs: {
      "href": "#/1_chapter2monarchsystem"
    }
  }, [_vm._v("CHAPTER 2 - MONARCH SYSTEM")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('a', {
    attrs: {
      "href": "#/2_chapter3firstclasspeak"
    }
  }, [_vm._v("CHAPTER 3 - FIRST-CLASS PEAK")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('a', {
    attrs: {
      "href": "#/3_chapter4assassination"
    }
  }, [_vm._v("CHAPTER 4 - ASSASSINATION")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('a', {
    attrs: {
      "href": "#/4_chapter5preparetoestablishauthority"
    }
  }, [_vm._v("CHAPTER 5 - PREPARE TO ESTABLISH AUTHORITY")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('a', {
    attrs: {
      "href": "#/5_chapter6siblingflower"
    }
  }, [_vm._v("CHAPTER 6 - SIBLING FLOWER")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('a', {
    attrs: {
      "href": "#/6_chapter7fallenheartflame"
    }
  }, [_vm._v("CHAPTER 7 - FALLEN HEART FLAME")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('a', {
    attrs: {
      "href": "#/7_chapter8xuerengui"
    }
  }, [_vm._v("CHAPTER 8 - XUE RENGUI")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/8_chapter9yuwenchengdu",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 9 - YUWEN CHENGDU")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/9_chapter10onedragonandtwophoenixes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 10 - ONE DRAGON AND TWO PHOENIXES")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/10_chapter11thefirstknifeofthenewemperor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 11 - THE FIRST KNIFE OF THE NEW EMPEROR")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/11_chapter12internalincision",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 12 - INTERNAL INCISION")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/12_chapter13eliminateyanfamily",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 13 - ELIMINATE YAN FAMILY")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/13_chapter14processingandappointment",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 14 - PROCESSING AND APPOINTMENT")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/14_chapter15contentionforpower",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 15 - CONTENTION FOR POWER")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/15_chapter16contralateralperforatingintestine",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 16 - CONTRALATERAL PERFORATING INTESTINE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/16_chapter17sworddance",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 17 - SWORD DANCE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/17_chapter18bloodstainedthroneroom",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 18 - BLOOD-STAINED THRONE ROOM")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/18_chapter19xuanyuansword",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 19 - XUAN-YUAN SWORD")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/19_chapter20longlivehismajesty",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 20 - LONG LIVE HIS MAJESTY")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/20_chapter21away",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 21 - AWAY")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/21_chapter22yanruyu",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 22 - YAN RUYU")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/22_chapter23collateitems",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 23 - COLLATE ITEMS")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/23_chapter24lotterydraw",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 24 - LOTTERY DRAW")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/24_chapter25floweringofbegonia",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 25 - FLOWERING OF BEGONIA")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/25_chapter26hypoheavydrug",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 26 - HYPO-HEAVY DRUG")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/26_chapter27gusantong",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 27 - GU SAN TONG")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/27_chapter28pastevents",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 28 - PAST EVENTS")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/28_chapter29cultivation",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 29 - CULTIVATION")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/29_chapter30xinjunssecondknife",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 30 - XINJUN'S SECOND KNIFE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/30_chapter31handtohand",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 31 - HAND-TO-HAND")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/31_chapter32annihilation",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 32 - ANNIHILATION")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/32_chapter33extermination",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 33 - EXTERMINATION")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/33_chapter34fortuitousbearsea",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 34 - FORTUITOUS BEAR SEA")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/34_chapter35ancientevil",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 35 - ANCIENT EVIL")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/35_chapter36xundoberman",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 36 - XUN DOBERMAN")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/36_chapter37lihouandzhangliang",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 37 - LI HOU AND ZHANG LIANG")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/37_chapter38reaction",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 38 - REACTION")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/38_chapter39cloudemissary",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 39 - CLOUD EMISSARY")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/39_chapter40puncturingshowoff",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 40 - PUNCTURING SHOW-OFF")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/40_chapter41beheading",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 41 - BEHEADING")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/41_chapter42countermeasures",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 42 - COUNTERMEASURES")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/42_chapter43pancakesintheimperialstudy",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 43 - PANCAKES IN THE IMPERIAL STUDY")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/43_chapter44zhugezheng",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 44 - ZHUGE ZHENG")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/44_chapter45partiesreactions",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 45 - PARTIES' REACTIONS")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/45_chapter46yuelinarmy",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 46 - YUELIN ARMY")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/46_chapter47innerbloodflow1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 47 - INNER BLOOD FLOW(1)")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/47_chapter48innerbloodflow2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 48 - INNER BLOOD FLOW(2)")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/48_chapter49clearthoroughly",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 49 - CLEAR THOROUGHLY")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/49_chapter50popularpraise",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 50 - POPULAR PRAISE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/50_chapter51exitingthecapitalcity",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 51 - EXITING THE CAPITAL CITY")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/51_chapter52cometothedoor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 52 - COME TO THE DOOR")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/52_chapter53uppercloud",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 53 - UPPER CLOUD")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/53_chapter54salidin",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 54 - SALIDIN")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/54_chapter55beheading",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 55 - BEHEADING")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/55_chapter56ascending",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 56 - ASCENDING")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/56_chapter57domineering",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 57 - DOMINEERING")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/57_chapter58maleorfemale",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 58 - MALE OR FEMALE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/58_chapter59warfare",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 59 - WARFARE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/59_chapter60compromise",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 60 - COMPROMISE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/60_chapter61sunmoongodcultaccession",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 61 - SUN MOON GOD CULT ACCESSION")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/61_chapter62surprise",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 62 - SURPRISE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/62_chapter63zhouyu",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 63 - ZHOU YU")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/63_chapter64wusongshen",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 64 - WU SONGSHEN")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/64_chapter65nightattackonwaterstronghold",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 65 - NIGHT ATTACK ON WATERSTRONGHOLD")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/65_chapter66thunderattack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 66 - THUNDER ATTACK")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/66_chapter67firstnavalbattle",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 67 - FIRST NAVAL BATTLE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/67_chapter68testzhouyu",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 68 - TEST ZHOU YU")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/68_chapter69straightattacktowusou",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 69 - STRAIGHT ATTACK TO WU SOU")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/69_chapter70generalqijiguang",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 70 - GENERAL QI JIGUANG")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/70_chapter71deceivingothersbytheirside",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 71 - DECEIVING OTHERS BY THEIR SIDE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/71_chapter72thecalculationofqinhui",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 72 - THE CALCULATION OF QIN HUI")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/72_chapter73straightblockade",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 73 - STRAIGHT BLOCKADE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/73_chapter74aquarelli",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 74 - AQUARELLI")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/74_chapter75strugglingthedevilisland",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 75 - STRUGGLING THE DEVIL ISLAND")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/75_chapter76killthedevilisland",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 76 - KILL THE DEVIL ISLAND")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/76_chapter77takedownavillage",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 77 - TAKE DOWN A VILLAGE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/77_chapter78captivegirl",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 78 - CAPTIVE GIRL")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/78_chapter79extortionofconfessionsbyseverepunishment",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 79 - EXTORTION OF CONFESSIONS BY SEVERE PUNISHMENT")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/79_chapter80rectificationoftheseaman",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 80 - RECTIFICATION OF THE SEAMAN")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/80_chapter81expeditionoftheusurper",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 81 - EXPEDITION OF THE USURPER")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/81_chapter82encounteringpirates",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 82 - ENCOUNTERING PIRATES")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/82_chapter83zhengshi",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 83 - ZHENG SHI")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/83_chapter84foursymbolsformation",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 84 - FOUR SYMBOLS FORMATION")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/84_chapter85kaiju",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 85 - KAIJU")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/85_chapter86zhengshishi",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 86 - ZHENG SHI SHI")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/86_chapter87boilteaondeck",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 87 - BOIL TEA ON DECK")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/87_chapter88theninja",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 88 - THE NINJA")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/88_chapter89endoparasite",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 89 - ENDOPARASITE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/89_chapter90assassination",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 90 - ASSASSINATION")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/90_chapter91throwyourselfintothearms",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 91 - THROW YOURSELF INTO THE ARMS")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/91_chapter92oldresentment",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 92 - OLD RESENTMENT")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/92_chapter93travelwiththeunitedstates",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 93 - TRAVEL WITH THE UNITED STATES")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/93_chapter94thecitygateswereclosed",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 94 - THE CITY GATES WERE CLOSED")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/94_chapter95midnightambush",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 95 - MIDNIGHT AMBUSH")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/95_chapter96flyingstonelikelightning",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 96 - FLYING STONE LIKE LIGHTNING")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/96_chapter97theyrehunting",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 97 - THEY'RE HUNTING")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/97_chapter98cityinn",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 98 - CITY INN")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/98_chapter99wishfulthinking",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 99 - WISHFUL THINKING")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/99_chapter100wishfulplanting",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 100 - WISHFUL PLANTING")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d3bbc574","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toc.vue
// module id = 57
// module chunks = 0